import type { ReactNode } from 'react'
export type NavItem = {
  name: string | ReactNode
  link?: string
}

export type NavbarProps = {
  navItems: NavItem[]
  visible: boolean
}

export const navItems = [
  {
    name: '功能',
    link: '/'
  },
  {
    name: '定价',
    link: '/price'
  },
  {
    name: '博客',
    link: '/blog'
  },
  {
    name: '文档',
    link: '/docs'
  },
  {
    name: '技能',
    link: '/skill'
  },
  {
    name: '联系我们',
    link: '/about'
  }
]

export const linksItems = [
  {
    name: '懂AI',
    link: 'https://www.dongaigc.com/'
  },
  {
    name: 'AI工具箱',
    link: 'https://ai-kit.cn/'
  },
  {
    name: '聚资源网',
    link: 'https://juzyw.com/'
  },
  {
    name: 'openI AI导航',
    link: 'https://openi.cn/'
  },
  {
    name: 'AI神器大全',
    link: 'https://aishenqi.net/'
  },
  {
    name: '网址之家',
    link: 'https://www.urlzj.com/'
  },
  {
    name: 'AI工具网',
    link: 'https://www.ai138.com/'
  },
  {
    name: 'AI导航',
    link: 'https://ai.dh0.cn'
  },
  {
    name: '发现AI',
    link: 'https://www.faxianai.com/'
  },
  {
    name: 'AIHub工具导航',
    link: 'https://www.aihub.cn'
  },
  {
    name: '爱AI工具库',
    link: 'https://www.2ai.cn/'
  },
  {
    name: 'COOL全能导航',
    link: 'https://nav.cocotoolset.cn'
  },
  {
    name: 'AI工具集',
    link: 'https://ai-bot.cn/'
  },
  {
    name: '攻壳智能体',
    link: 'https://gongke.net/'
  },
  {
    name: '硬核指南',
    link: 'https://yinghezhinan.com/'
  }
]
